// Angular Files
import {
 Component, Inject, Input, ChangeDetectorRef, HostBinding, ViewChild, ElementRef, DOCUMENT
} from '@angular/core';

// Service Files
import { TellerOnlineAppService } from '../../services/app.service';
import { TellerOnlineFocusRestorationService } from '../../services/focus-restoration.service';

@Component({
    selector: 'teller-online-load-panel',
    templateUrl: './load-panel.component.html',
    styleUrls: ['./load-panel.component.scss'],
    host: {
        class: 'load-panel'
    },
    standalone: false
})
export class TellerOnlineLoadPanelComponent {
    @ViewChild('loader') loader: ElementRef;

    // Declare @Input variables
    @Input() loadedMessage: any = 'Loaded';

    // Private variables
    private _pageLoadActive: boolean = false;

    private _siteLoadActive: boolean = false;

    // Subscriptions

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private focusService: TellerOnlineFocusRestorationService,
        public appService: TellerOnlineAppService,
        public cdr: ChangeDetectorRef
    ) {
        // anytime the page loading state changes, toggle the class
        this.appService.pageLoading$.subscribe(isActive => {
            this._pageLoadActive = isActive;
            this.setActive();
        });

        // anytime the page loading state changes, toggle the class
        this.appService.loading$.subscribe(isActive => {
            this._siteLoadActive = isActive;
            this.setActive();
        });
    }

    @HostBinding('class.load-panel--active') protected isActive = true;

    public setActive() {
        const active = this.document.activeElement as HTMLElement;
        const isLoader = active === this.loader?.nativeElement;
        const isBody = active === this.document.body;

        if (!this.isActive && !isLoader && !isBody) {
            this.focusService.save('load-panel');
        }

        this.isActive = this._siteLoadActive || this._pageLoadActive;

        setTimeout(() => {
            if (this.isActive) {
                this.loader.nativeElement.focus();
            } else {
                // Don't override focus that another component
                // already restored to a meaningful element
                const current = this.document.activeElement as HTMLElement;
                const isOnLoader = current === this.loader?.nativeElement;
                const isOnBody = current === this.document.body;

                if (isOnLoader || isOnBody || !current) {
                    this.focusService.restore('load-panel');
                }
            }
        }, 0);
    }
}
